<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">local_gas_station</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">{{ _isEdicao ? 'Editar Código ANP' : 'Adicionar Código ANP' }}</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <form class="form pt-2" [formGroup]="model">
    <div class="row">
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Código ANP (9 dígitos)</mat-label>
          <input matInput formControlName="codigo" maxlength="9" inputmode="numeric" placeholder="000000000"
            (input)="somenteDigitos($event)" />
          @if (model.get('codigo')?.touched && model.get('codigo')?.invalid) {
          <mat-error>Informe 9 dígitos numéricos.</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-md-8">
        <mat-form-field appearance="outline">
          <mat-label>Descrição ANP</mat-label>
          <input matInput formControlName="descricao" placeholder="Descrição oficial do produto" />
          @if (model.get('descricao')?.touched && model.get('descricao')?.invalid) {
          <mat-error>Informe a descrição.</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Unidade de Medida</mat-label>
          <mat-select formControlName="idUnidadeMedida">
            @for (u of data.unidades; track u.id) {
            <mat-option [value]="u.id">{{ u.descricao }}</mat-option>
            }
          </mat-select>
          @if (model.get('idUnidadeMedida')?.touched && model.get('idUnidadeMedida')?.invalid) {
          <mat-error>Selecione a unidade.</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Regime ICMS</mat-label>
          <mat-select formControlName="idRegimeIcms">
            @for (r of data.regimes; track r.id) {
            <mat-option [value]="r.id">{{ r.descricao }}</mat-option>
            }
          </mat-select>
          @if (model.get('idRegimeIcms')?.touched && model.get('idRegimeIcms')?.invalid) {
          <mat-error>Selecione o regime.</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Indicador de Importação</mat-label>
          <mat-select formControlName="idIndicadorImportacao">
            <mat-option [value]="null">—</mat-option>
            @for (i of data.indicadores; track i.id) {
            <mat-option [value]="i.id">{{ i.codigo }} - {{ i.descricao }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Alíquota ad rem do ICMS (R$/unidade)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask"
            formControlName="aliquotaIcmsPorUnidade" placeholder="R$ 0,0000" />
        </mat-form-field>
      </div>

      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Alíquota ad rem de retenção (R$ por unidade)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask"
            formControlName="aliquotaIcmsRetencaoPorUnidade" placeholder="R$ 0,0000" />
          <mat-hint>Por padrão, igual à alíquota ad rem do ICMS; pode ser editada.</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="toggles">
      <div class="toggle-row">
        <mat-slide-toggle formControlName="exigePbio">Percentual de mistura de Biodiesel (pBio)
          <span class="material-symbols-outlined" [matTooltip]="tooltipPbio">info</span>
        </mat-slide-toggle>
      </div>
      <div class="toggle-row">
        <mat-slide-toggle formControlName="exigeGrupoGlp">Exige Grupo GLP
          <span class="material-symbols-outlined" [matTooltip]="tooltipGlp">info</span>
        </mat-slide-toggle>
      </div>
      <div class="toggle-row">
        <mat-slide-toggle formControlName="isAtivo">Ativo</mat-slide-toggle>
      </div>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()" [disabled]="_isLoading">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="salvar()" [disabled]="_isLoading">Salvar</button>
</mat-dialog-actions>
